"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _endsWith = _interopRequireDefault(require("lodash/endsWith"));

var _emotion = require("emotion");

var _input = _interopRequireDefault(require("@amzn/meridian-tokens/component/input"));

var _theme = require("../theme");

var _inputBox = _interopRequireDefault(require("../_input-box"));

var _useFocus2 = _interopRequireDefault(require("../_use-focus"));

var _token = require("./../_utils/token");

var _inputReset = _interopRequireDefault(require("./../_styles/input-reset"));

var _filterPropsByPrefix = _interopRequireDefault(require("./../_utils/filter-props-by-prefix"));

var _supportTextWrapper = _interopRequireDefault(require("../_support-text-wrapper"));

var _getSupportTextAriaDescribedby = _interopRequireDefault(require("./../_utils/get-support-text-aria-describedby"));

var _functional = require("./../_utils/functional");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sizeStyles = (0, _token.memoizeTokenStyles)(function (t, _ref) {
  var label = _ref.label;
  var insetHorizontal = t("spacingInsetHorizontal");
  var insetVertical = t("spacingInsetVerticalAuto");
  return (0, _emotion.css)({
    lineHeight: t("lineHeightAuto"),
    minHeight: t("lineHeightAuto"),
    // Clear out the padding applied by input-box (except for the top padding
    // if we have a label)
    margin: "".concat(label ? 0 : -insetVertical, "px -").concat(insetHorizontal, "px -").concat(insetVertical, "px -").concat(insetHorizontal, "px"),
    // Re-apply the input-box padding inside the textarea. This ensures that
    // the textarea resize handle fits snug in the corner of the input-box and
    // that when scrolling the textarea content can go right up to the bottom
    // of the input-box.
    padding: "".concat(label ? 0 : insetVertical, "px ").concat(insetHorizontal, "px ").concat(insetVertical, "px ").concat(insetHorizontal, "px")
  });
}, ["label"]);
var textareaStyles = (0, _token.memoizeTokenStyles)(function (t, _ref2) {
  var disabled = _ref2.disabled,
      empty = _ref2.empty,
      label = _ref2.label,
      resize = _ref2.resize;
  return (0, _emotion.css)((0, _inputReset["default"])({
    empty: empty,
    textColor: t("foregroundColor", disabled ? "disabled" : "default"),
    placeholderColor: t("placeholderColor", disabled ? "disabled" : "default")
  }), {
    position: resize === "auto" ? "absolute" : undefined,
    height: resize === "auto" ? "100%" : undefined,
    boxSizing: resize === "auto" ? "border-box" : undefined,
    resize: "none",
    overflow: resize === "auto" ? "hidden" : "auto",
    overflowWrap: "break-word",
    // For IE, Edge, & Safari
    wordWrap: "break-word"
  }, sizeStyles(t, {
    label: label
  }));
}, ["disabled", "empty", "label", "resize"]);
var autoResizeContainerStyles = (0, _token.memoizeTokenStyles)(function (t, _ref3) {
  var label = _ref3.label,
      rows = _ref3.rows;
  return (0, _emotion.css)({
    position: "relative",
    "& > div": {
      overflowWrap: "break-word",
      // For IE, Edge, & Safari
      wordWrap: "break-word",
      whiteSpace: "pre-wrap",
      pointerEvents: "none",
      opacity: 0,
      minHeight: "".concat(parseInt(t("lineHeightAuto")) * rows, "px")
    }
  }, sizeStyles(t, {
    label: label
  }));
}, ["label", "rows"]);
var widthStyles = (0, _functional.memoizeByKeys)(function (_ref4) {
  var width = _ref4.width;
  return (0, _emotion.css)({
    width: width,
    // If an explicit width is set then don't allow the textarea to flex
    flex: width ? "none !important" : undefined
  });
}, ["width"]); // This returns a value that will ensure the component always stays in a
// controlled state. Without this the underlying textarea element might end
// up in an uncontrolled state and the DOM and the component could get out of
// sync.

var getControlledValue = function getControlledValue(value) {
  return value === null || value === undefined ? "" : value;
}; // This returns a value that, when placed in the auto resize container, will
// force the component to the exact height needed to fit the textarea without
// scrolling.


var getAutoResizeValue = function getAutoResizeValue(value) {
  return (// The `white-space: pre-wrap` CSS property will not actually render a
    // trailing newline, but a textarea will. To ensure that our resize
    // container matches the textarea we have to add an extra newline if the
    // value ends in a newline.
    (0, _endsWith["default"])(value, "\n") ? "".concat(value, "\n") : value
  );
};

var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (props, forwardedRef) {
  var disabled = props.disabled,
      onChange = props.onChange;
  var t = (0, _theme.useTheme)(_input["default"], "input"); // Generate a unique id that can be used to reference this element in the DOM

  var id = (0, _react.useMemo)(function () {
    return props.id || (0, _uniqueId["default"])("textarea-");
  }, [props.id]);
  var localRef = (0, _react.useRef)();
  var value = getControlledValue(props.value);
  var empty = value === "";
  var onChangeTextarea = (0, _react.useCallback)(function (event) {
    if (!disabled) onChange(event.target.value);
  }, [onChange, disabled]); // Focus on the input anytime the user mouses down on the container. This
  // mimicks the default browser behavior when a user mouses down on an input.

  var onMouseDownContainer = (0, _react.useCallback)(function (event) {
    if (localRef.current && event.target !== localRef.current) {
      event.preventDefault();
      localRef.current.focus();
    }
  }, [localRef]); // Assign the local and prop ref (if it exists) to the target ref (textarea)

  var assignRefs = (0, _react.useCallback)(function (targetRef) {
    localRef.current = targetRef;

    if (forwardedRef) {
      // Assign the ref with a function (Class components) or assigning .current
      // (modern functional components using the `useRef` hook)
      if (typeof forwardedRef === "function") {
        forwardedRef(targetRef);
      } else {
        forwardedRef.current = targetRef;
      }
    }
  }, [forwardedRef]);

  var _useFocus = (0, _useFocus2["default"])(props),
      focus = _useFocus.focus,
      focusProps = _useFocus.focusProps;

  var passThroughProps = (0, _filterPropsByPrefix["default"])(props, ["data-", "aria-"]);

  var textarea = /*#__PURE__*/_react["default"].createElement("textarea", (0, _extends2["default"])({
    "aria-label": props.label,
    "aria-describedby": (0, _getSupportTextAriaDescribedby["default"])({
      id: id,
      hasHelperText: !!props.helperText,
      hasConstraintText: !!props.constraintText,
      hasErrorMessage: !!props.errorMessage,
      errorMessageFirst: props.size === "medium"
    })
  }, passThroughProps, focusProps, {
    className: textareaStyles(t, _objectSpread(_objectSpread({}, props), {}, {
      empty: empty
    })),
    id: id,
    name: props.name,
    ref: assignRefs,
    value: value,
    rows: props.rows,
    placeholder: props.placeholder,
    disabled: props.disabled,
    autoFocus: props.autoFocus || props.inaccessibleAutoFocus,
    onChange: onChangeTextarea,
    wrap: "on",
    autoComplete: props.autoFill ? undefined : "off",
    spellCheck: props.spellcheck
  }));

  return /*#__PURE__*/_react["default"].createElement(_supportTextWrapper["default"], {
    id: id,
    helperText: props.helperText,
    constraintText: props.constraintText,
    errorMessage: props.errorMessage,
    helperBelowFormField: !!props.label,
    className: widthStyles({
      width: props.width
    })
  }, /*#__PURE__*/_react["default"].createElement(_inputBox["default"], {
    size: "auto",
    fontSize: props.label ? undefined : props.size,
    label: props.label,
    error: props.error,
    disabled: props.disabled,
    focus: focus,
    empty: empty,
    onMouseDown: onMouseDownContainer,
    htmlFor: id,
    cursor: "text"
  }, props.resize === "auto" ? /*#__PURE__*/_react["default"].createElement("div", {
    className: autoResizeContainerStyles(t, props)
  }, textarea, /*#__PURE__*/_react["default"].createElement("div", {
    "aria-hidden": "true"
  }, getAutoResizeValue(value))) : textarea));
});

Textarea.displayName = "Textarea";
Textarea.propTypes = process.env.NODE_ENV !== "production" ? {
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]).isRequired,

  /**
   * A function that will be called when the user attempts to change the value
   * of the component (e.g. by typing in the textarea). The new value will be
   * passed as the first argument to this function.
   *
   * Meridian uses [controlled components](https://reactjs.org/docs/forms.html#controlled-components),
   * so you must track the values provided to this function somewhere in state
   * and pass them back via the `value` prop in order to make this component
   * interactive.
   */
  onChange: _propTypes["default"].func.isRequired,

  /**
   * All props prefixed with `aria-` are accepted. This is useful for adding [aria
   * attributes](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA) for improved accessibility.
   *
   * @since 5.10.1
   */
  "aria-*": _propTypes["default"].string,

  /**
   * Allow the browser to suggest auto-fill values for this input.
   *
   * Note that not all browsers respect this property. Some browsers (e.g.
   * Chrome 78) may choose to *always* allow auto-fill regardless of the value
   * of this property.
   */
  autoFill: _propTypes["default"].bool,

  /**
   * NOTE: This is deprecated and will be removed in 6.x, use `inaccessibleAutoFocus` instead.
   *
   * @deprecated 5.18.0
   */
  autoFocus: _propTypes["default"].bool,

  /**
   * Add constraint text to provide critical information regarding textarea content.
   *
   * @since 5.22.0
   */
  constraintText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * All props prefaced with `data-` are accepted. This is useful for
   * integrating with other libraries such as Amplify Analytics or Cypress.
   *
   * @since 5.x
   */
  "data-*": _propTypes["default"].string,

  /**
   * This disables interaction with the component and applies special visual
   * styles to indicate that it's not interactive.
   */
  disabled: _propTypes["default"].bool,

  /**
   * Show the component in an error state. Use this to indicate that the value
   * of the component is invalid.
   *
   * Consider pairing this state with a small error `Alert` component below
   * or to the right of the component explaining what the error is.
   */
  error: _propTypes["default"].bool,

  /**
   * An explanation for why the error state has occurred.
   * This will show as an xsmall [Alert](https://meridian.a2z.com/components/alert/) below the Textarea.
   *
   * @since 5.22.0
   */
  errorMessage: _propTypes["default"].string,

  /**
   * Add helper text to provide additional instruction.
   *
   * @since 5.22.0
   */
  helperText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /**
   * Sets an `id` attribute on the component's form element.
   *
   * Use this for testing or for accessibility. Do not use this in order to apply override styles
   * to the component. The markup and styles rendered by Meridian components
   * are private APIs, and may change without notice.
   */
  id: _propTypes["default"].string,

  /**
   * If set to true then the textarea will grab focus as soon as it's mounted.
   *
   * This uses HTML's native `autofocus` attribute. Use this sparingly as
   * there are [common accessibility pitfalls](https://www.brucelawson.co.uk/2009/the-accessibility-of-html-5-autofocus/)
   * associated with this behavior.
   *
   * @since 5.18.0
   */
  inaccessibleAutoFocus: _propTypes["default"].bool,

  /**
   * A label for the textarea.
   */
  label: _propTypes["default"].string,

  /**
   * The name of the component's form control. If the component is placed in a
   * form, this will be the name associated with the component's data when the
   * form is submitted.
   */
  name: _propTypes["default"].string,

  /**
   * Text that is shown in place of the textarea's value when the textarea is empty.
   *
   * This text is not visible when a value is entered in the textarea, so it should
   * not contain essential information that should be persisted. For that,
   * consider using the `label` prop.
   */
  placeholder: _propTypes["default"].string,

  /**
   * Determines the behavior of the textarea when the text it contains
   * overflows.
   *
   * If this is set to `"auto"` the textarea will expand vertically to ensure
   * that it can contain text without requiring a scrollbar. If this is set to
   * `"none"` the textarea's height will be fixed and a scrollbar will be shown
   * when its text overflows vertically.
   */
  resize: _propTypes["default"].oneOf(["auto", "none"]),

  /**
   * The height of the text area specified in terms of a number of rows of text.
   *
   * If `resize` is set to `"auto"` the text area may grow taller than this
   * value, but it will never be shorter.
   */
  rows: _propTypes["default"].number,

  /**
   * Sets the size of the component using a preset.
   *
   * If the `label` prop is provided this prop will be ignored (the label
   * requires a particular amount of space which is not configurable).
   */
  size: _propTypes["default"].oneOf(["small", "medium"]),

  /**
   * Enable or disable spellchecking on the Textarea. See [the MDN documentation for `spellcheck`](https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/spellcheck).
   *
   * @since 5.23.0
   */
  spellcheck: _propTypes["default"].bool,

  /**
   * Set the width of the component using a number (which will be treated
   * as pixels) or a string containing any valid CSS dimension.
   */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /**
   * This is called when the component loses focus. The [blur event](https://developer.mozilla.org/en-US/docs/Web/API/Element/blur_event)
   * is passed as the first argument to the function.
   */
  onBlur: _propTypes["default"].func,

  /**
   * This is called when the component gains focus. The [focus event](https://developer.mozilla.org/en-US/docs/Web/API/Element/focus_event)
   * is passed as the first argument to the function.
   */
  onFocus: _propTypes["default"].func
} : {};
Textarea.defaultProps = {
  resize: "auto",
  rows: 2,
  onFocus: _noop["default"],
  onBlur: _noop["default"],
  autoFill: true,
  size: "medium"
};
var _default = Textarea;
exports["default"] = _default;